import { rad2deg } from "@hscmap/angle";
import { utils } from "@hscmap/stellar-globe";
import { database } from "@/modules/ssp_database/database";
import { ImageCutoutModule } from "@/modules/ssp_database/ImageCutoutModule";
import axios from 'axios'
import { Component, Prop, Vue } from "vue-property-decorator";
import { env } from '@/env';
import { store } from '@/store';

interface ITractRerun { tract: number, rerun: string }

@Component
export default class ImageCutoutComponent extends Vue {
  @Prop({ required: true })
  module!: ImageCutoutModule

  release = env.releases.default
  filetype = 'coadd'
  image = true
  mask = false
  variance = false
  filter = 'HSC-I'
  tractReruns: ITractRerun[] = []
  tractRerunIndex = -1
  ajaxing = false

  get infoUrl() {
    const rect = store.modules.tool.rect
    if (this.module.showWindow && rect) {
      const { a: a0, d: d0 } = rect.c0
      const { a: a1, d: d1 } = rect.c1
      // tslint:disable-next-line:max-line-length
      return `${this.release.cutoutUrl}?ra1=${a0.deg}&dec1=${d0.deg}&ra2=${a1.deg}&dec2=${d1.deg}&filter=${this.filter}&type=info`
    }
  }

  created() {
    this.$watch('infoUrl', utils.debounce(500, () => {
      this.infoUrl && this.updateTractReruns(this.infoUrl)
    }), { immediate: true })
  }

  private updateTractReruns(infoUrl: string) {
    database.login(async () => {
      this.ajaxing = true
      this.tractRerunIndex = -1
      const { data: tractReruns } = await axios.get<ITractRerun[]>(infoUrl)
      if (infoUrl === this.infoUrl) {
        this.tractReruns = tractReruns
        this.ajaxing = false
      }
    })
  }

  cutout() {
    const rect = store.modules.tool.rect
    if (rect) {
      const { a: a0, d: d0 } = rect.c0
      const { a: a1, d: d1 } = rect.c1
      const layer = [
        ...(this.image ? ['image=on'] : []),
        ...(this.mask ? ['mask=on'] : []),
        ...(this.variance ? ['variance=on'] : []),
      ].join('&')
      const { tract, rerun } = this.tractReruns[this.tractRerunIndex]
      // tslint:disable-next-line:max-line-length
      const url = `${this.release.cutoutUrl}?ra1=${a0.deg}&dec1=${d0.deg}&ra2=${a1.deg}&dec2=${d1.deg}&type=${this.filetype}&${layer}&filter=${this.filter}&tract=${tract}&rerun=${rerun}`
      window.open(url)
    }
  }

  available() {
    return this.tractRerunIndex >= 0 && !this.ajaxing
  }
}
